// ==============================
// Elemente auswählen
// ==============================
const fontSizeValueElement = document.getElementById('font-size-value');
const textPreview = document.getElementById('text-preview-3');

const plusButton = document.querySelector('.text-styling__plus');
const minusButton = document.querySelector('.text-styling__minus');

const topButton = document.querySelector('.text-styling__top');
const bottomButton = document.querySelector('.text-styling__bottom');
const leftButton = document.querySelector('.text-styling__left');
const rightButton = document.querySelector('.text-styling__right');

const xInput = document.getElementById('x-input');
const yInput = document.getElementById('y-input');

const resetButton = document.querySelector('.text-styling__reset');

const rotationInput = document.getElementById('rotation-input');
const rotateLeftButton = document.querySelector('.text-styling__rotate-left');
const rotateRightButton = document.querySelector('.text-styling__rotate-right');
const resetRotationButton = document.querySelector('.text-styling__reset-rotation');

const textTabElem = document.getElementById('text_tab'); // Motiv Tab Element

// Adjusted-Input-Felder
const textSizeAdjustedInput = document.getElementById('text-size-adjusted');

// Default-Input-Felder
const xInputDefault = document.getElementById('x-input-default');
const yInputDefault = document.getElementById('y-input-default');
const rotationInputDefault = document.getElementById('rotation-input-default');
const textSizeDefaultInput = document.getElementById('text-size-default');

// Sicherheits-Check (falls Elemente mal nicht existieren)
if (!textPreview) {
  console.warn('textPreview (#text-preview-3) nicht gefunden – Script stoppt.');
} else {
  // ==============================
  // Klick auf Preview -> Tab öffnen
  // ==============================
  if (textTabElem) {
    textPreview.addEventListener('click', () => {
      textTabElem.click();
    });
  }

  // ==============================
  // Hilfsfunktionen
  // ==============================
  function getTextTransformValues(element) {
    const style = window.getComputedStyle(element);
    const transform = style.transform;

    let x = 0, y = 0, rotation = 0;

    if (transform && transform !== 'none') {
      const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
      if (matrixMatch) {
        const values = matrixMatch[1].split(',').map(val => parseFloat(val.trim()));
        if (values.length === 6) {
          x = values[4];
          y = values[5];
          rotation = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
        }
      }
    }

    // Fallback: aus style="" lesen (falls vorhanden)
    const styleAttr = element.getAttribute('style') || '';

    const translateXMatch = styleAttr.match(/translateX\(([^)]+)px\)/);
    if (translateXMatch) x = parseFloat(translateXMatch[1]);

    const translateYMatch = styleAttr.match(/translateY\(([^)]+)px\)/);
    if (translateYMatch) y = parseFloat(translateYMatch[1]);

    const rotateMatch = styleAttr.match(/rotate\(([^)]+)deg\)/);
    if (rotateMatch) rotation = parseFloat(rotateMatch[1]);

    return { x, y, rotation };
  }

  function getCurrentFontSize() {
    return parseInt(window.getComputedStyle(textPreview).fontSize);
  }

  // ==============================
  // Globale Live-Werte (Adjusted)
  // ==============================
  let xPosition = 0;
  let yPosition = 0;
  let rotationAngle = 0;
  let fontSize = 0;

  // ==============================
  // Default-State (1x speichern)
  // ==============================
  let hasCapturedDefaults = false;
  const defaultValues = { x: 0, y: 0, rotation: 0, fontSize: 0 };

  function fillDefaultInputs() {
    if (xInputDefault) xInputDefault.value = defaultValues.x + 'px';
    if (yInputDefault) yInputDefault.value = defaultValues.y + 'px';
    if (rotationInputDefault) rotationInputDefault.value = defaultValues.rotation + 'deg';
    if (textSizeDefaultInput) textSizeDefaultInput.value = defaultValues.fontSize + 'px';
  }

  function captureDefaultsOnce() {
    if (hasCapturedDefaults) return;

    const v = getTextTransformValues(textPreview);
    const fs = getCurrentFontSize();

    defaultValues.x = v.x;
    defaultValues.y = v.y;
    defaultValues.rotation = v.rotation;
    defaultValues.fontSize = fs;

    fillDefaultInputs();
    hasCapturedDefaults = true;

    console.log('Defaults gecaptured:', { ...defaultValues });
  }

  // Optional: Capturen erst wenn Werte "sinnvoll" sind (z.B. nicht alles 0)
  // -> hilft, wenn mtext erst nachträglich Styles setzt
  function tryCaptureDefaultsSmart() {
    if (hasCapturedDefaults) return;

    const v = getTextTransformValues(textPreview);
    const fs = getCurrentFontSize();

    const looksLikeNotReady =
      (v.x === 0 && v.y === 0 && v.rotation === 0) && (fs === 0 || isNaN(fs));

    // Wenn FontSize normal ist, ist meistens ready
    if (!looksLikeNotReady && !isNaN(fs) && fs > 0) {
      defaultValues.x = v.x;
      defaultValues.y = v.y;
      defaultValues.rotation = v.rotation;
      defaultValues.fontSize = fs;

      fillDefaultInputs();
      hasCapturedDefaults = true;

      console.log('Defaults (smart) gecaptured:', { ...defaultValues });
    }
  }

  // ==============================
  // Initialisieren (Adjusted füllen)
  // ==============================
  function initializeAdjustedValues() {
    const t = getTextTransformValues(textPreview);
    xPosition = t.x;
    yPosition = t.y;
    rotationAngle = t.rotation;
    fontSize = getCurrentFontSize();

    if (fontSizeValueElement) fontSizeValueElement.textContent = fontSize + 'px';
    if (textSizeAdjustedInput) textSizeAdjustedInput.value = fontSize + 'px';

    if (xInput) xInput.value = xPosition + 'px';
    if (yInput) yInput.value = yPosition + 'px';
    if (rotationInput) rotationInput.value = rotationAngle + 'deg';

    console.log('Adjusted initialisiert:', { xPosition, yPosition, rotationAngle, fontSize });
  }

  initializeAdjustedValues();

  // 1 Frame warten, dann defaults capturen (falls mtext schon ready)
  requestAnimationFrame(() => {
    tryCaptureDefaultsSmart();

    // Fallback: wenn nach 1 Frame noch nicht gecaptured, in 300ms nochmals probieren
    if (!hasCapturedDefaults) {
      setTimeout(() => {
        tryCaptureDefaultsSmart();
        // Wenn immer noch nicht -> zwingend capturen (dann halt 0/0/0 falls wirklich so)
        if (!hasCapturedDefaults) captureDefaultsOnce();
      }, 300);
    }
  });

  // ==============================
  // Button gedrückt halten
  // ==============================
  let intervalId;

  function handleTextButton(button, action) {
    if (!button) return;

    // Desktop
    button.addEventListener('mousedown', () => {
      action();
      intervalId = setInterval(action, 100);
    });
    button.addEventListener('mouseup', () => clearInterval(intervalId));
    button.addEventListener('mouseleave', () => clearInterval(intervalId));

    // Mobile
    button.addEventListener('touchstart', (e) => {
      e.preventDefault();
      action();
      intervalId = setInterval(action, 100);
    });
    button.addEventListener('touchend', () => clearInterval(intervalId));
    button.addEventListener('touchcancel', () => clearInterval(intervalId));
  }

  // ==============================
  // Update-Funktionen (nur Adjusted ändern)
  // ==============================
  function updateTextFontSize() {
    textPreview.style.fontSize = fontSize + 'px';
    if (fontSizeValueElement) fontSizeValueElement.textContent = fontSize + 'px';
    if (textSizeAdjustedInput) textSizeAdjustedInput.value = fontSize + 'px';
  }

  function updateTextTransform() {
    textPreview.style.transform = `translateX(${xPosition}px) translateY(${yPosition}px) rotate(${rotationAngle}deg)`;
  }

  function updateTextPosition() {
    updateTextTransform();
    if (xInput) xInput.value = xPosition + 'px';
    if (yInput) yInput.value = yPosition + 'px';
    // Default-Felder bleiben unverändert
  }

  function updateTextRotation() {
    updateTextTransform();
    if (rotationInput) rotationInput.value = rotationAngle + 'deg';
    // Default-Felder bleiben unverändert
  }

  // ==============================
  // Schriftgrösse ändern
  // ==============================
  handleTextButton(plusButton, () => {
    const current = getCurrentFontSize();
    fontSize = current + 2;
    updateTextFontSize();
  });

  handleTextButton(minusButton, () => {
    const current = getCurrentFontSize();
    if (current > 2) {
      fontSize = current - 2;
      updateTextFontSize();
    }
  });

  // ==============================
  // Position ändern
  // ==============================
  handleTextButton(topButton, () => {
    yPosition -= 2;
    updateTextPosition();
  });

  handleTextButton(bottomButton, () => {
    yPosition += 2;
    updateTextPosition();
  });

  handleTextButton(leftButton, () => {
    xPosition -= 2;
    updateTextPosition();
  });

  handleTextButton(rightButton, () => {
    xPosition += 2;
    updateTextPosition();
  });

  // ==============================
  // Rotation ändern
  // ==============================
  handleTextButton(rotateLeftButton, () => {
    rotationAngle -= 1;
    updateTextRotation();
  });

  handleTextButton(rotateRightButton, () => {
    rotationAngle += 1;
    updateTextRotation();
  });

  // ==============================
  // Input-Felder (Adjusted)
  // ==============================
  if (xInput) {
    xInput.addEventListener('input', () => {
      xPosition = parseInt(String(xInput.value).replace('px', ''), 10) || 0;
      updateTextPosition();
    });
  }

  if (yInput) {
    yInput.addEventListener('input', () => {
      yPosition = parseInt(String(yInput.value).replace('px', ''), 10) || 0;
      updateTextPosition();
    });
  }

  if (rotationInput) {
    rotationInput.addEventListener('input', () => {
      rotationAngle = parseInt(String(rotationInput.value).replace('deg', ''), 10) || 0;
      updateTextRotation();
    });
  }

  // ==============================
  // Reset-Buttons -> zurück auf Default
  // ==============================
  if (resetButton) {
    resetButton.addEventListener('click', () => {
      // sicherstellen, dass defaults existieren
      if (!hasCapturedDefaults) captureDefaultsOnce();

      xPosition = defaultValues.x;
      yPosition = defaultValues.y;
      updateTextPosition();
    });
  }

  if (resetRotationButton) {
    resetRotationButton.addEventListener('click', () => {
      if (!hasCapturedDefaults) captureDefaultsOnce();

      rotationAngle = defaultValues.rotation;
      updateTextRotation();
    });
  }

  // ==============================
  // MutationObserver: erkennt externe Änderungen (z.B. mtext)
  // - Adjusted aktualisieren
  // - Defaults beim ersten externen "echten" Set 1x capturen
  // ==============================
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        // Wenn defaults noch nicht da sind, versuche smart zu capturen
        if (!hasCapturedDefaults) {
          tryCaptureDefaultsSmart();
        }

        const newValues = getTextTransformValues(textPreview);
        const newFontSize = getCurrentFontSize();

        const changed =
          newValues.x !== xPosition ||
          newValues.y !== yPosition ||
          newValues.rotation !== rotationAngle ||
          newFontSize !== fontSize;

        if (changed) {
          initializeAdjustedValues();
        }
      }
    });
  });

  observer.observe(textPreview, {
    attributes: true,
    attributeFilter: ['style']
  });
}